<template>
  <section class="custom-header-wrapper">
    <div class="row mb-2">
      <div class="col-md-12 custom-inline">
        <eval-over
          ref="evalOver"
          v-show="isShow"
          @changed="changedEval"
          class="me-2"
        />
        <search ref="search" v-show="isShow" class="me-2" />
        <challenge-lookup
          ref="challengeLookup"
          v-show="isShow"
          @changed="changedChallenge"
        />
        <refresh ref="refresh" v-show="isShow" @refresh="refresh" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EvalOver from './elements/evaluate-over'
import ChallengeLookup from './elements/challenge-lookup'
import Search from './elements/search'
import Refresh from './elements/refresh'
export default {
  name: 'dashboard-header',
  components: {
    EvalOver,
    ChallengeLookup,
    Search,
    Refresh,
  },
  data() {
    return {
      evalOption: 'numWeeks',
      numWeeks: 1,
      dateStart: null,
      dateEnd: null,
      selectedChallenge: null,
      isData: false,
    }
  },
  mounted() {
    this.init()
  },
  emits: ['evalChanged', 'challengeChanged', 'refresh', 'download'],
  computed: {
    ...mapGetters('reporting', ['analysis', 'challengeProgress']),
    ...mapGetters('organizations', ['examineOrganization']),
    isShow() {
      let _is
      if (this.examineOrganization) {
        _is = true
      }
      return _is
    },
  },
  methods: {
    init() {
      this.isData = false
      if (this.examineOrganization) {
        this.$refs.challengeLookup.loadChallenges(this.examineOrganization.id)
      }
    },
    changedEval() {
      this.$emit('evalChanged')
    },
    changedChallenge() {
      this.$emit('challengeChanged')
    },
    refresh() {
      this.isData = true
      this.$emit('refresh')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header-wrapper {
  position: relative;
}
.custom-inline {
  display: inline-flex;
}
</style>
